import React from 'react'

import { TogglesProvider, type TogglesProviderConfig } from '@acorns/web-toggles-react'
import { useAnalyticsClient } from '@acorns/web-utils'
import { USER_UUID } from 'app-constants'
import CenteredSpinner from 'components/CenteredSpinner/CenteredSpinner'
import initialFlagsJson from 'static/initial-flags-backup.json'
import { ENV } from 'utils/environment'

export function AcornsHelloTogglesProvider({ children }: { children: React.ReactNode }) {
  const analyticsClient = useAnalyticsClient()

  const togglesProviderConfig: TogglesProviderConfig = {
    sdkKey: process.env.AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY,
    userAttributes: {
      userId: window.sessionStorage.getItem(USER_UUID) ?? undefined,
      deviceId: analyticsClient.getAnonymousId(),
    },
    waitForInitialization: true,
    waitForInitializationLoadingComponent: CenteredSpinner,
    allowToggleOverrides: process.env.BUILD_ENV !== ENV.Production,
    amplitudeExperimentExposureTrackingProvider: {
      track(exposure) {
        if (exposure && exposure.variant) {
          analyticsClient.track('$exposure', {
            experiment_key: exposure.experiment_key ?? '',
            flag_key: exposure.flag_key,
            variant: exposure.variant,
          })
        }
      },
    },
    amplitudeExperimentFlagsServerUrl: process.env.AMPLITUDE_EXPERIMENT_FLAGS_SERVER_URL,
    amplitudeExperimentServerUrl: process.env.AMPLITUDE_EXPERIMENT_SERVER_URL,
    amplitudeExperimentUserProvider: {
      getUser() {
        return {
          userId: window.sessionStorage.getItem(USER_UUID) ?? undefined,
          device_id: analyticsClient.getAnonymousId(),
        }
      },
    },
    amplitudeExperimentInitialFlagsJson: JSON.stringify(initialFlagsJson),
  }

  return <TogglesProvider {...togglesProviderConfig}>{children}</TogglesProvider>
}
